module.exports = __webpack_public_path__ + "img/metro_redmarker.ee40eab6.png";